import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=4663f07d&scoped=true&"
import script from "./Logo.vue?vue&type=script&lang=js&"
export * from "./Logo.vue?vue&type=script&lang=js&"
import style0 from "./Logo.vue?vue&type=style&index=0&id=4663f07d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../animod-code-conversion/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4663f07d",
  null
  
)

export default component.exports